<div class="flex gap-2">
  @if (!expanded()) {
    <p-button
      type="button"
      icon="pi pi-plus"
      [label]="'common.expandAll' | transloco"
      (onClick)="onExpandAll()"
      [text]="true"
      [disabled]="expandAllDisabled()"
      data-testid="expand-all-button"
    />
  } @else {
    <p-button
      type="button"
      icon="pi pi-minus"
      [label]="'common.collapseAll' | transloco"
      (onClick)="onCollapseAll()"
      [text]="true"
      [disabled]="collapseAllDisabled()"
      data-testid="collapse-all-button"
    />
  }
</div>
